import type { StreamEntry } from "./types.js";

// Where the run of queued prompts at the end of a conversation starts (length: none).
export function queuedTailStart(entries: readonly StreamEntry[]): number {
  let at = entries.length;
  while (at > 0) {
    const e = entries[at - 1];
    if (e.kind !== "user_message" || e.queued !== true) break;
    at -= 1;
  }
  return at;
}
